module.exports = __webpack_public_path__ + "static/media/offc-data-visualization.4c2be42d.png";